// extracted by mini-css-extract-plugin
export default {"nav":"App_nav__Yz+gE"};